import { render } from "./AddYear.vue?vue&type=template&id=5190724e&scoped=true"
import script from "./AddYear.vue?vue&type=script&lang=js"
export * from "./AddYear.vue?vue&type=script&lang=js"

import "./AddYear.vue?vue&type=style&index=0&id=5190724e&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5190724e"]])

export default __exports__